import { useMemo } from 'react';
import type { Bond } from '../types/bonds';
import { BOND_CONSTANTS } from '../constants/bonds';

export function useBondFilters(bonds: Bond[] | undefined, selectedType: string) {
  // Filter bonds by selected type
  const filteredBonds = useMemo(() => {
    if (!bonds || !selectedType) return [];
    return bonds.filter(bond => bond.type === selectedType);
  }, [bonds, selectedType]);

  // Get bond info for header (first bond of selected type)
  const selectedBondInfo = useMemo(() => {
    if (!filteredBonds.length) return null;
    const firstBond = filteredBonds[0];
    return {
      name: firstBond.name,
      type: firstBond.type
    };
  }, [filteredBonds]);

  // Get periods only from the filtered bonds (selected tab)
  const periodsForSelectedTab = useMemo(() => {
    if (!filteredBonds.length) return [];
    const periods = new Set<string>();
    filteredBonds.forEach(bond => {
      Object.keys(bond.interestRates).forEach(key => {
        if (key !== BOND_CONSTANTS.CUMULATED_VALUE_KEY) {
          periods.add(key);
        }
      });
    });
    return Array.from(periods).sort((a, b) => {
      // Sort numerically if possible, otherwise alphabetically
      const aNum = parseInt(a);
      const bNum = parseInt(b);
      if (!isNaN(aNum) && !isNaN(bNum)) {
        return aNum - bNum;
      }
      return a.localeCompare(b);
    });
  }, [filteredBonds]);

  return {
    filteredBonds,
    selectedBondInfo,
    periodsForSelectedTab
  };
} 